import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import {
  getAllEmployeeList,
  getEmployeeFullDetails,
  updateEmployeeStatus,
  updateRole,
  updatePersonalDetails,
} from '../services/employeeDataService';

import { EmployeeDataInitialState } from '../utils/Types';
import { API_STATUS, BlankPagination } from '../utils/Constant';
import { isAPISuccess } from '../utils/Util';
import { blankUserDetails } from './assignGridSlice';
import { findTaskStatusOptions } from '../pages/task-assigned/TaskAssignHelper';
import { getStatusDrop } from '../services/dropDownService';

export const fetchAllEmployeeList = createAsyncThunk(
  'attendance/fetchAllEmployeeList',
  async (data: any) => {
    const res = await getAllEmployeeList(data);
    return res.data;
  }
);
export const fetchEmployeeDetails = createAsyncThunk(
  'attendance/fetchEmployeeDetails',
  async (param: any) => {
    const res = await getEmployeeFullDetails(param);
    return res.data;
  }
);
export const fetchEmployeeStatusDrops = createAsyncThunk(
  'attendance/fetchEmployeeStatusDrops',
  async () => {
    const res = await getStatusDrop({ module: 10 });
    return res.data;
  }
);
export const updateEmployeeStatusDrops = createAsyncThunk(
  'attendance/updateEmployeeStatusDrops',
  async (data: any) => {
    const res = await updateEmployeeStatus(data);
    return res.data;
  }
);
export const updateEmployeeRole = createAsyncThunk(
  'attendance/updateEmployeeRole',
  async (data: any) => {
    const res = await updateRole(data);
    return res.data;
  }
);
export const updateEmployeePersonalDetails = createAsyncThunk(
  'attendance/updateEmployeePersonalDetails',
  async (data: any) => {
    const res = await updatePersonalDetails(data);
    return res.data;
  }
);
const initialState: EmployeeDataInitialState = {
  employeeList: [],
  pagination: BlankPagination,
  employeeDetails: {
    campaignDetails: [],
    allocatedGrids: [],
    roleDetails: [],
    reporteesDetails: [],
    reportingManagerDetails: {
      candidateId: 0,
      candidateUniqueId: '',
      employeeUniqueId: '',
      fullName: '',
      photo: '',
      roleName: '',
    },
    reportingDetails: {
      zone: 0,
      zoneName: '',
      state: 0,
      stateName: '',
      district: 0,
      districtName: '',
      city: 0,
      cityName: '',
      pincode: '',
      employeeType: 0,
      employeeTypeName: '',
      employeeStatus: 0,
      employeeStatusName: '',
      role: 0,
    },
    personalDetails: blankUserDetails,
  },
  employeeStatus: [],
  roleUpdateStatus: {
    response: {
      responseCode: '',
      responseMessage: '',
    },
    status: null,
  },
};
export const employeeDataSlice = createSlice({
  name: 'employeeData',
  initialState,
  reducers: {
    clearUpdateEmployeeRoleStatus: (state) => {
      state.roleUpdateStatus.status = null;
      state.roleUpdateStatus.response = {
        responseCode: '',
        responseMessage: '',
      };
    },
  },
  extraReducers(builder) {
    builder
      .addCase(fetchAllEmployeeList.fulfilled, (state, action) => {
        if (isAPISuccess(action.payload)) {
          state.employeeList = action.payload.result;
          state.pagination = action.payload.pagination;
        } else {
          state.employeeList = [];
          state.pagination = BlankPagination;
        }
      })
      .addCase(fetchEmployeeDetails.fulfilled, (state, action) => {
        if (isAPISuccess(action.payload)) {
          state.employeeDetails = action.payload.result;
        } else {
          state.employeeDetails = null;
        }
      })
      .addCase(fetchEmployeeStatusDrops.fulfilled, (state, action) => {
        if (isAPISuccess(action.payload)) {
          const array = findTaskStatusOptions(action.payload.result);
          state.employeeStatus = array;
        } else {
          state.employeeStatus = [];
        }
      })
      .addCase(updateEmployeeRole.fulfilled, (state, action) => {
        state.roleUpdateStatus.response = action.payload.responseInformation;
        if (isAPISuccess(action.payload)) {
          state.roleUpdateStatus.status = API_STATUS.SUCCEEDED;
        } else {
          state.roleUpdateStatus.status = API_STATUS.FAILED;
        }
      })
      .addCase(updateEmployeePersonalDetails.fulfilled, (state, action) => {
        state.roleUpdateStatus.response = action.payload.responseInformation;
        if (isAPISuccess(action.payload)) {
          state.roleUpdateStatus.status = API_STATUS.SUCCEEDED;

          if (state.employeeDetails && action.payload.result) {
            state.employeeDetails.personalDetails = {
              ...state.employeeDetails.personalDetails,
              ...action.payload.result,
            };
          }
        } else {
          state.roleUpdateStatus.status = API_STATUS.FAILED;
        }
      })
      .addCase(updateEmployeeRole.rejected, (state, action) => {
        state.roleUpdateStatus.status = API_STATUS.FAILED;
        state.roleUpdateStatus.response = {
          responseCode: '1',
          responseMessage: 'Something went wrong',
        };
      });
  },
});
export const employeeDataSelector = (state: {
  employeeData: EmployeeDataInitialState;
}) => state.employeeData;
export const { clearUpdateEmployeeRoleStatus } = employeeDataSlice.actions;
export default employeeDataSlice.reducer;
